import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { useCreateBoat } from "@actions/boatActions";
import React, { useState } from "react";

const NewBoatModal = ({ open, setOpen, onSave }) => {
  const [name, setName] = useState("");
  const [addBoat] = useCreateBoat();

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = (e) => {
    e.preventDefault();
    addBoat({
      variables: {
        input: { name },
      },
    }).then((r) => {
      onSave(r.data.createBoat.id);
    });
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      disableBackdropClick={true}
    >
      <form onSubmit={handleSave}>
        <DialogTitle id="form-dialog-title">New Boat</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter the boats name, after which you will be taken to the
            boat setup wizard.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Boat Name"
            fullWidth
            value={name}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default NewBoatModal;
